import React, {useState} from 'react';
import {startApplication} from "../api/applicationAPI";
import {navigate} from "../navigation/navigationHistory";
import {Button, Spin} from "antd";
import Input from "antd/lib/input";
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: '38px' }} spin />;
/**
 * Application in a sense of a Policy!
 */
export function StartApplicationWidget(props) {
  const {
    buttonLabel,
    retrieveQuoteLabel,
    carrierGroupId,
    licenseClass,
    errorMessage,
    secondErrorMessage,
    unavailableErrorMessage
  } = props;
  const [{ loading, displayErrorMessage, postalCode, errorText }, setStatus] = useState({
    loading: false,
    displayErrorMessage: false,
    postalCode: '',
    errorText: ''
  });
  const unavailableDefault = 'Thank you for visiting our website.  We are currently undergoing maintenance and cannot process your request.  Please visit us again later or call us for assistance.';
  const unavailableMsg = unavailableErrorMessage || unavailableDefault;

  function start() {
    setStatus({
      loading: true
    });
    startApplication({
      carrierGroupId: carrierGroupId,
      postalCode: postalCode,
      licenseClass: licenseClass
    })
      .then(systemId => navigate(`/application/${systemId}`))
      .catch(err => {
        const statusCode = (err.response ? err.response.status : 0);

        let  msg = `${errorMessage} ${postalCode}. ${displaySecondaryErrorMessage}`;
        msg =  ((statusCode === 0 || (statusCode === 400)) ? msg :  unavailableMsg);

        setStatus({
          postalCode,
          loading: false,
          displayErrorMessage: true,
          errorText: msg
        })
        if (statusCode === 503) navigate('/server-maintenance');  // This is unlikely to happen
	  }
      );
  }

  const isValueInteger = value => {
    const firstNonNum = value.split('').find(v => {
      const valInt = parseInt(v);
      return valInt !== valInt;
    });
    const allCharsAreIntegers = typeof firstNonNum === "undefined";
    return allCharsAreIntegers;
  }

  const onInputChange = e => {
    const value = e.target.value;
    if (value !== postalCode && (isValueInteger(value) || value === '')) {
      setStatus({ postalCode: value });
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Spin indicator={antIcon} />
      </div>
    );
  }
  
  const retrieveQuote = () => {
    scrollTo(0, 0);
    navigate('/retrieve-quote');
  }

  const displaySecondaryErrorMessage = secondErrorMessage ? secondErrorMessage : '';
  const headerTextEl = document.querySelector('.millions-of-people-text');
  const secondaryErrMsgEl = document.getElementById('secondary-error-message')
  if(displayErrorMessage && headerTextEl && !secondaryErrMsgEl){
    const newEl = document.createElement('div');
    newEl.setAttribute('class', 'info-banner');
    newEl.setAttribute('id', 'secondary-error-message');
    newEl.innerText = `${errorText}`;
    headerTextEl.parentNode.insertBefore(newEl, headerTextEl);
	scrollTo({
	  top: 0,
	  behavior: 'smooth',
	});
  } else if(!displayErrorMessage && secondaryErrMsgEl){
    secondaryErrMsgEl.parentNode.removeChild(secondaryErrMsgEl);
  }

  return (
    <>
    <div className='start-application-widget'>
        <Input
          aria-label="Enter zip code"
          placeholder='Enter Zip Code'
          value={postalCode}
          onChange={onInputChange}
          className='input-postal-code-text'
          onPressEnter={() => start()}
        />
      <Button className='start-quote-button' type='primary' onClick={() => start()} disabled={!postalCode}>
        {buttonLabel}
      </Button>
      <Button className='retrieve-quote-button' type='link' onClick={retrieveQuote}>
        {retrieveQuoteLabel}
      </Button>
    </div>
    </>
  );
}
